<cc-progress-bar [isLoading]="isLoading$ | async"></cc-progress-bar>
@if (data$ | async; as data) {
  @if (layout$ | async; as layout) {
    <div
      class="flex flex-col gap-2"
      [class.mca--auto]="layout === 'auto'"
      [class.mca--vertical]="layout === 'vertical'"
      [class.mca--horizontal]="layout === 'horizontal'"
    >
      <div class="grid gap-y-1 gap-x-2 items-start mca__grid">
        <!-- Customer Name -->
        <div
          class="text-sm text-gray-700"
          transloco="widgetType-MarketCustomerAnalysis.customerName"
        ></div>
        <div
          class="flex gap-2 items-center min-w-0"
          [attr.title]="data.customer.name"
        >
          <span
            class="inline-block flex-shrink-0 w-2.5 h-2.5 rounded-full bg-primary-color-500"
            [class.bg-red-500]="!data.customer.active"
          ></span>
          <div class="truncate">
            {{ data.customer.name }}
          </div>
        </div>

        <!-- Customer Segment -->
        <div class="text-gray-700 text-md">
          {{ 'widgetType-MarketCustomerAnalysis.customerSegment' | transloco }}
        </div>
        <div class="min-w-0">
          <div
            class="text-sm text-gray-900 truncate"
            [attr.title]="data.customer.segment"
          >
            {{ data.customer.segment }}
          </div>
        </div>

        <!-- Users -->
        <div class="text-sm text-gray-700">
          {{ 'widgetType-MarketCustomerAnalysis.users' | transloco }}
        </div>
        <div class="min-w-0">
          <div class="flex flex-wrap gap-1">
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-primary-color-500]="data.customer.users.active > 0"
              [class.bg-gray-500]="data.customer.users.active === 0"
              [attr.title]="'bo.common.energysources.POWER' | transloco"
            >
              {{ data.customer.users.active | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{ data.customer.users.inactive | number: '1.0-0' }}
            </span>
          </div>
        </div>

        <!-- Load Profile -->
        <div class="text-sm text-gray-700">
          {{ 'widgetType-MarketCustomerAnalysis.profiles' | transloco }}
        </div>
        <div class="min-w-0">
          <div class="flex flex-wrap gap-1">
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-primary-color-500]="data.loadProfile.power.active > 0"
              [class.bg-gray-500]="data.loadProfile.power.active === 0"
              [attr.title]="'bo.common.energysources.POWER' | transloco"
            >
              {{ data.loadProfile.power.active | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{ data.loadProfile.power.inactive | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 ml-3 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-yellow-300]="data.loadProfile.gas.active > 0"
              [class.bg-gray-500]="data.loadProfile.gas.active === 0"
              [attr.title]="'bo.common.energysources.GAS' | transloco"
            >
              {{ data.loadProfile.gas.active | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{ data.loadProfile.gas.inactive | number: '1.0-0' }}
            </span>
          </div>
        </div>

        <!-- Forecast -->
        <div class="text-sm text-gray-700">
          {{ 'widgetType-MarketCustomerAnalysis.forecast' | transloco }}
        </div>
        <div class="min-w-0">
          <div class="flex flex-wrap gap-1">
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-primary-color-500]="data.forecast.power.active > 0"
              [class.bg-gray-500]="data.forecast.power.active === 0"
              [attr.title]="'bo.common.energysources.POWER' | transloco"
            >
              {{ data.forecast.power.active | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{ data.forecast.power.inactive | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 ml-3 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-yellow-300]="data.forecast.gas.active > 0"
              [class.bg-gray-500]="data.forecast.gas.active === 0"
              [attr.title]="'bo.common.energysources.GAS' | transloco"
            >
              {{ data.forecast.gas.active | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{ data.forecast.gas.inactive | number: '1.0-0' }}
            </span>
          </div>
        </div>

        <!-- Offers -->
        <div class="text-sm text-gray-700">
          {{ 'widgetType-MarketCustomerAnalysis.offers' | transloco }}
        </div>
        <div class="min-w-0">
          <div class="flex flex-wrap gap-1">
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-primary-color-500]="data.offer.power.active > 0"
              [class.bg-gray-500]="data.offer.power.active === 0"
              [attr.title]="'bo.common.energysources.POWER' | transloco"
            >
              {{ data.offer.power.active | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{ data.offer.power.inactive | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 ml-3 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-yellow-300]="data.offer.gas.active > 0"
              [class.bg-gray-500]="data.offer.gas.active === 0"
              [attr.title]="'bo.common.energysources.GAS' | transloco"
            >
              {{ data.offer.gas.active | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{ data.offer.gas.inactive | number: '1.0-0' }}
            </span>
          </div>
        </div>

        <!-- Contracts -->
        <div class="text-sm text-gray-700">
          {{ 'widgetType-MarketCustomerAnalysis.contracts' | transloco }}
        </div>
        <div class="min-w-0">
          <div class="flex flex-wrap gap-1">
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-primary-color-500]="data.contracts.power.active > 0"
              [class.bg-gray-500]="data.contracts.power.active === 0"
              [attr.title]="'bo.common.energysources.POWER' | transloco"
            >
              {{ data.contracts.power.active | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{ data.contracts.power.inactive | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 ml-3 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-yellow-300]="data.contracts.gas.active > 0"
              [class.bg-gray-500]="data.contracts.gas.active === 0"
              [attr.title]="'bo.common.energysources.GAS' | transloco"
            >
              {{ data.contracts.gas.active | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{ data.contracts.gas.inactive | number: '1.0-0' }}
            </span>
          </div>
        </div>

        <div
          class="pt-2 mt-2 text-sm font-bold text-gray-700 border-t border-gray-200"
        >
          {{ 'widgetType-MarketCustomerAnalysis.limitReports' | transloco }}
        </div>
        <div class="min-w-0"></div>

        <!-- Limit Reports - Power -->
        <div class="text-sm text-gray-700">
          {{ 'bo.common.energysources.POWER' | transloco }}
        </div>
        <div class="min-w-0">
          <div class="flex flex-wrap gap-1">
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-primary-color-500]="data.limitReports.power.open > 0"
              [class.bg-gray-500]="data.limitReports.power.open === 0"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.open' | transloco
              "
            >
              {{ data.limitReports.power.open | number: '1.0-2' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.closed' | transloco
              "
            >
              {{ data.limitReports.power.closed | number: '1.0-2' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.closedPercentage' | transloco
              "
            >
              {{ data.limitReports.power.closedPercentage | percent: '1.0-2' }}
            </span>
          </div>
        </div>

        <!-- Limit Reports - Gas -->
        <div class="text-sm text-gray-700">
          {{ 'bo.common.energysources.GAS' | transloco }}
        </div>
        <div class="min-w-0">
          <div class="flex flex-wrap gap-1">
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-yellow-300]="data.limitReports.gas.open > 0"
              [class.bg-gray-500]="data.limitReports.gas.open === 0"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.open' | transloco
              "
            >
              {{ data.limitReports.gas.open | number: '1.0-2' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.closed' | transloco
              "
            >
              {{ data.limitReports.gas.closed | number: '1.0-2' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.closedPercentage' | transloco
              "
            >
              {{ data.limitReports.gas.closedPercentage | percent: '1.0-2' }}
            </span>
          </div>
        </div>

        <!-- Limit Reports - Other -->
        <div class="text-sm text-gray-700">
          {{ 'bo.common.analysis-type.ENERGY_MARKET_OTHER' | transloco }}
        </div>
        <div class="min-w-0">
          <div class="flex flex-wrap gap-1">
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-primary-color-500]="data.limitReports.other.open > 0"
              [class.bg-gray-500]="data.limitReports.other.open === 0"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.open' | transloco
              "
            >
              {{ data.limitReports.other.open | number: '1.0-2' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.closed' | transloco
              "
            >
              {{ data.limitReports.other.closed | number: '1.0-2' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.closedPercentage' | transloco
              "
            >
              {{ data.limitReports.other.closedPercentage | percent: '1.0-2' }}
            </span>
          </div>
        </div>

        <!-- Energy Orders - Power Section Header -->
        <div
          class="pt-2 mt-2 text-sm font-bold text-gray-700 border-t border-gray-200"
        >
          {{ 'widgetType-MarketCustomerAnalysis.energyOrders' | transloco }} -
          {{ 'bo.common.energysources.POWER' | transloco }}
        </div>
        <div class="min-w-0"></div>

        <!-- Energy Orders - Power: Energy Order -->
        <div class="text-sm text-gray-700">
          {{ 'widgetType-MarketCustomerAnalysis.energyOrder' | transloco }}
        </div>
        <div class="min-w-0">
          <div class="flex flex-wrap gap-1">
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-primary-color-500]="
                data.energyOrders.power.energyOrder.active > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.power.energyOrder.active === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.active' | transloco
              "
            >
              {{ data.energyOrders.power.energyOrder.active | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{
                data.energyOrders.power.energyOrder.inactive | number: '1.0-0'
              }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-amber-500]="
                data.energyOrders.power.energyOrder.waitingApproval > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.power.energyOrder.waitingApproval === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.waitingApproval' | transloco
              "
            >
              {{
                data.energyOrders.power.energyOrder.waitingApproval
                  | number: '1.0-0'
              }}
            </span>
          </div>
        </div>

        <!-- Energy Orders - Power: Spread Energy Order -->
        <div class="text-sm text-gray-700">
          {{
            'widgetType-MarketCustomerAnalysis.spreadEnergyOrder' | transloco
          }}
        </div>
        <div class="min-w-0">
          <div class="flex flex-wrap gap-1">
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-primary-color-500]="
                data.energyOrders.power.spreadEnergyOrder.active > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.power.spreadEnergyOrder.active === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.active' | transloco
              "
            >
              {{
                data.energyOrders.power.spreadEnergyOrder.active
                  | number: '1.0-0'
              }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{
                data.energyOrders.power.spreadEnergyOrder.inactive
                  | number: '1.0-0'
              }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-amber-500]="
                data.energyOrders.power.spreadEnergyOrder.waitingApproval > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.power.spreadEnergyOrder.waitingApproval === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.waitingApproval' | transloco
              "
            >
              {{
                data.energyOrders.power.spreadEnergyOrder.waitingApproval
                  | number: '1.0-0'
              }}
            </span>
          </div>
        </div>

        <!-- Energy Orders - Power: Spot -->
        <div class="text-sm text-gray-700">
          {{ 'widgetType-MarketCustomerAnalysis.spot' | transloco }}
        </div>
        <div class="min-w-0">
          <div class="flex flex-wrap gap-1">
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-primary-color-500]="
                data.energyOrders.power.spot.active > 0
              "
              [class.bg-gray-500]="data.energyOrders.power.spot.active === 0"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.active' | transloco
              "
            >
              {{ data.energyOrders.power.spot.active | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{ data.energyOrders.power.spot.inactive | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-amber-500]="
                data.energyOrders.power.spot.waitingApproval > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.power.spot.waitingApproval === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.waitingApproval' | transloco
              "
            >
              {{
                data.energyOrders.power.spot.waitingApproval | number: '1.0-0'
              }}
            </span>
          </div>
        </div>

        <!-- Energy Orders - Power: Spot Spread -->
        <div class="text-sm text-gray-700">
          {{ 'widgetType-MarketCustomerAnalysis.spotSpread' | transloco }}
        </div>
        <div class="min-w-0">
          <div class="flex flex-wrap gap-1">
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-primary-color-500]="
                data.energyOrders.power.spotSpread.active > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.power.spotSpread.active === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.active' | transloco
              "
            >
              {{ data.energyOrders.power.spotSpread.active | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{
                data.energyOrders.power.spotSpread.inactive | number: '1.0-0'
              }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-amber-500]="
                data.energyOrders.power.spotSpread.waitingApproval > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.power.spotSpread.waitingApproval === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.waitingApproval' | transloco
              "
            >
              {{
                data.energyOrders.power.spotSpread.waitingApproval
                  | number: '1.0-0'
              }}
            </span>
          </div>
        </div>

        <!-- Energy Orders - Power: Strategy Message -->
        <div class="text-sm text-gray-700">
          {{ 'widgetType-MarketCustomerAnalysis.strategyMessage' | transloco }}
        </div>
        <div class="min-w-0">
          <div class="flex flex-wrap gap-1">
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-primary-color-500]="
                data.energyOrders.power.strategyMessage.active > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.power.strategyMessage.active === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.active' | transloco
              "
            >
              {{
                data.energyOrders.power.strategyMessage.active | number: '1.0-0'
              }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{
                data.energyOrders.power.strategyMessage.inactive
                  | number: '1.0-0'
              }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-amber-500]="
                data.energyOrders.power.strategyMessage.waitingApproval > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.power.strategyMessage.waitingApproval === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.waitingApproval' | transloco
              "
            >
              {{
                data.energyOrders.power.strategyMessage.waitingApproval
                  | number: '1.0-0'
              }}
            </span>
          </div>
        </div>

        <!-- Energy Orders - Power: Strategy Message Spread -->
        <div class="text-sm text-gray-700">
          {{
            'widgetType-MarketCustomerAnalysis.strategyMessageSpread'
              | transloco
          }}
        </div>
        <div class="min-w-0">
          <div class="flex flex-wrap gap-1">
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-primary-color-500]="
                data.energyOrders.power.strategyMessageSpread.active > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.power.strategyMessageSpread.active === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.active' | transloco
              "
            >
              {{
                data.energyOrders.power.strategyMessageSpread.active
                  | number: '1.0-0'
              }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{
                data.energyOrders.power.strategyMessageSpread.inactive
                  | number: '1.0-0'
              }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-amber-500]="
                data.energyOrders.power.strategyMessageSpread.waitingApproval >
                0
              "
              [class.bg-gray-500]="
                data.energyOrders.power.strategyMessageSpread
                  .waitingApproval === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.waitingApproval' | transloco
              "
            >
              {{
                data.energyOrders.power.strategyMessageSpread.waitingApproval
                  | number: '1.0-0'
              }}
            </span>
          </div>
        </div>

        <!-- Energy Orders - Power: Limit Order -->
        <div class="text-sm text-gray-700">
          {{ 'widgetType-MarketCustomerAnalysis.limitOrder' | transloco }}
        </div>
        <div class="min-w-0">
          <div class="flex flex-wrap gap-1">
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-primary-color-500]="
                data.energyOrders.power.limitOrder.active > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.power.limitOrder.active === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.active' | transloco
              "
            >
              {{ data.energyOrders.power.limitOrder.active | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{
                data.energyOrders.power.limitOrder.inactive | number: '1.0-0'
              }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-amber-500]="
                data.energyOrders.power.limitOrder.waitingApproval > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.power.limitOrder.waitingApproval === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.waitingApproval' | transloco
              "
            >
              {{
                data.energyOrders.power.limitOrder.waitingApproval
                  | number: '1.0-0'
              }}
            </span>
          </div>
        </div>

        <!-- Energy Orders - Power: HKN -->
        <div class="text-sm text-gray-700">
          {{ 'widgetType-MarketCustomerAnalysis.hkn' | transloco }}
        </div>
        <div class="min-w-0">
          <div class="flex flex-wrap gap-1">
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-primary-color-500]="
                data.energyOrders.power.hkn.active > 0
              "
              [class.bg-gray-500]="data.energyOrders.power.hkn.active === 0"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.active' | transloco
              "
            >
              {{ data.energyOrders.power.hkn.active | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{ data.energyOrders.power.hkn.inactive | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-amber-500]="
                data.energyOrders.power.hkn.waitingApproval > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.power.hkn.waitingApproval === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.waitingApproval' | transloco
              "
            >
              {{
                data.energyOrders.power.hkn.waitingApproval | number: '1.0-0'
              }}
            </span>
          </div>
        </div>

        <!-- Energy Orders - Power: HKN Limit Order -->
        <div class="text-sm text-gray-700">
          {{ 'widgetType-MarketCustomerAnalysis.hknLimitOrder' | transloco }}
        </div>
        <div class="min-w-0">
          <div class="flex flex-wrap gap-1">
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-primary-color-500]="
                data.energyOrders.power.hknLimitOrder.active > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.power.hknLimitOrder.active === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.active' | transloco
              "
            >
              {{
                data.energyOrders.power.hknLimitOrder.active | number: '1.0-0'
              }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{
                data.energyOrders.power.hknLimitOrder.inactive | number: '1.0-0'
              }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-amber-500]="
                data.energyOrders.power.hknLimitOrder.waitingApproval > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.power.hknLimitOrder.waitingApproval === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.waitingApproval' | transloco
              "
            >
              {{
                data.energyOrders.power.hknLimitOrder.waitingApproval
                  | number: '1.0-0'
              }}
            </span>
          </div>
        </div>

        <!-- Energy Orders - Power: Trading Request -->
        <div class="text-sm text-gray-700">
          {{ 'widgetType-MarketCustomerAnalysis.tradingRequest' | transloco }}
        </div>
        <div class="min-w-0">
          <div class="flex flex-wrap gap-1">
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-primary-color-500]="
                data.energyOrders.power.tradingRequest.active > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.power.tradingRequest.active === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.active' | transloco
              "
            >
              {{
                data.energyOrders.power.tradingRequest.active | number: '1.0-0'
              }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{
                data.energyOrders.power.tradingRequest.inactive
                  | number: '1.0-0'
              }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-amber-500]="
                data.energyOrders.power.tradingRequest.waitingApproval > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.power.tradingRequest.waitingApproval === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.waitingApproval' | transloco
              "
            >
              {{
                data.energyOrders.power.tradingRequest.waitingApproval
                  | number: '1.0-0'
              }}
            </span>
          </div>
        </div>

        <!-- Energy Orders - Gas Section Header -->
        <div
          class="pt-2 mt-2 text-sm font-bold text-gray-700 border-t border-gray-200"
        >
          {{ 'widgetType-MarketCustomerAnalysis.energyOrders' | transloco }} -
          {{ 'bo.common.energysources.GAS' | transloco }}
        </div>
        <div class="min-w-0"></div>

        <!-- Energy Orders - Gas: Energy Order -->
        <div class="text-sm text-gray-700">
          {{ 'widgetType-MarketCustomerAnalysis.energyOrder' | transloco }}
        </div>
        <div class="min-w-0">
          <div class="flex flex-wrap gap-1">
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-yellow-300]="
                data.energyOrders.gas.energyOrder.active > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.gas.energyOrder.active === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.active' | transloco
              "
            >
              {{ data.energyOrders.gas.energyOrder.active | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{ data.energyOrders.gas.energyOrder.inactive | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-amber-500]="
                data.energyOrders.gas.energyOrder.waitingApproval > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.gas.energyOrder.waitingApproval === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.waitingApproval' | transloco
              "
            >
              {{
                data.energyOrders.gas.energyOrder.waitingApproval
                  | number: '1.0-0'
              }}
            </span>
          </div>
        </div>

        <!-- Energy Orders - Gas: Spot -->
        <div class="text-sm text-gray-700">
          {{ 'widgetType-MarketCustomerAnalysis.spot' | transloco }}
        </div>
        <div class="min-w-0">
          <div class="flex flex-wrap gap-1">
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-yellow-300]="data.energyOrders.gas.spot.active > 0"
              [class.bg-gray-500]="data.energyOrders.gas.spot.active === 0"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.active' | transloco
              "
            >
              {{ data.energyOrders.gas.spot.active | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{ data.energyOrders.gas.spot.inactive | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-amber-500]="
                data.energyOrders.gas.spot.waitingApproval > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.gas.spot.waitingApproval === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.waitingApproval' | transloco
              "
            >
              {{ data.energyOrders.gas.spot.waitingApproval | number: '1.0-0' }}
            </span>
          </div>
        </div>

        <!-- Energy Orders - Gas: Strategy Message -->
        <div class="text-sm text-gray-700">
          {{ 'widgetType-MarketCustomerAnalysis.strategyMessage' | transloco }}
        </div>
        <div class="min-w-0">
          <div class="flex flex-wrap gap-1">
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-yellow-300]="
                data.energyOrders.gas.strategyMessage.active > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.gas.strategyMessage.active === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.active' | transloco
              "
            >
              {{
                data.energyOrders.gas.strategyMessage.active | number: '1.0-0'
              }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{
                data.energyOrders.gas.strategyMessage.inactive | number: '1.0-0'
              }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-amber-500]="
                data.energyOrders.gas.strategyMessage.waitingApproval > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.gas.strategyMessage.waitingApproval === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.waitingApproval' | transloco
              "
            >
              {{
                data.energyOrders.gas.strategyMessage.waitingApproval
                  | number: '1.0-0'
              }}
            </span>
          </div>
        </div>

        <!-- Energy Orders - Gas: Limit Order -->
        <div class="text-sm text-gray-700">
          {{ 'widgetType-MarketCustomerAnalysis.limitOrder' | transloco }}
        </div>
        <div class="min-w-0">
          <div class="flex flex-wrap gap-1">
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-yellow-300]="
                data.energyOrders.gas.limitOrder.active > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.gas.limitOrder.active === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.active' | transloco
              "
            >
              {{ data.energyOrders.gas.limitOrder.active | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{ data.energyOrders.gas.limitOrder.inactive | number: '1.0-0' }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-amber-500]="
                data.energyOrders.gas.limitOrder.waitingApproval > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.gas.limitOrder.waitingApproval === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.waitingApproval' | transloco
              "
            >
              {{
                data.energyOrders.gas.limitOrder.waitingApproval
                  | number: '1.0-0'
              }}
            </span>
          </div>
        </div>

        <!-- Energy Orders - Gas: Trading Request -->
        <div class="text-sm text-gray-700">
          {{ 'widgetType-MarketCustomerAnalysis.tradingRequest' | transloco }}
        </div>
        <div class="min-w-0">
          <div class="flex flex-wrap gap-1">
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-yellow-300]="
                data.energyOrders.gas.tradingRequest.active > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.gas.tradingRequest.active === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.active' | transloco
              "
            >
              {{
                data.energyOrders.gas.tradingRequest.active | number: '1.0-0'
              }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white bg-gray-500 rounded-md"
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.inactive' | transloco
              "
            >
              {{
                data.energyOrders.gas.tradingRequest.inactive | number: '1.0-0'
              }}
            </span>
            <span
              class="inline-flex justify-center items-center px-2 py-1 w-12 text-sm font-bold leading-none text-center text-white rounded-md"
              [class.bg-amber-500]="
                data.energyOrders.gas.tradingRequest.waitingApproval > 0
              "
              [class.bg-gray-500]="
                data.energyOrders.gas.tradingRequest.waitingApproval === 0
              "
              [attr.title]="
                'widgetType-MarketCustomerAnalysis.waitingApproval' | transloco
              "
            >
              {{
                data.energyOrders.gas.tradingRequest.waitingApproval
                  | number: '1.0-0'
              }}
            </span>
          </div>
        </div>
      </div>

      <div class="flex flex-col gap-2">
        <div class="text-sm text-gray-700 dark:text-layout-dark-sidenav-text">
          {{ 'widgetType-MarketCustomerAnalysis.kam' | transloco }}
        </div>
        <div class="grid gap-2 kam__grid">
          <div
            class="p-2 bg-white rounded-md border border-gray-200 dark:bg-layout-dark-card dark:border-layout-dark-border"
          >
            <div
              class="mb-1 font-bold text-gray-900 dark:text-layout-dark-page-container-text"
            >
              {{ 'bo.common.energysources.POWER' | transloco }}
            </div>
            @if ((data.customer.kam.power ?? []).length > 0) {
              <div class="flex flex-wrap gap-1">
                @for (item of data.customer.kam.power ?? []; track item) {
                  <span
                    class="inline-flex items-center px-2 py-0.5 text-xs text-gray-800 bg-gray-100 rounded-full dark:bg-layout-dark-input dark:text-layout-dark-page-container-text"
                    >{{ item }}</span
                  >
                }
              </div>
            } @else {
              <div class="text-sm italic text-gray-500 dark:text-gray-500">
                {{ 'bo.common.NO_DATA' | transloco }}
              </div>
            }
          </div>
          <div
            class="p-2 bg-white rounded-md border border-gray-200 dark:bg-layout-dark-card dark:border-layout-dark-border"
          >
            <div
              class="mb-1 font-bold text-gray-900 dark:text-layout-dark-page-container-text"
            >
              {{ 'bo.common.energysources.GAS' | transloco }}
            </div>
            @if ((data.customer.kam.gas ?? []).length > 0) {
              <div class="flex flex-wrap gap-1">
                @for (item of data.customer.kam.gas ?? []; track item) {
                  <span
                    class="inline-flex items-center px-2 py-0.5 text-xs text-gray-800 bg-gray-100 rounded-full dark:bg-layout-dark-input dark:text-layout-dark-page-container-text"
                    >{{ item }}</span
                  >
                }
              </div>
            } @else {
              <div class="text-sm italic text-gray-500 dark:text-gray-500">
                {{ 'bo.common.NO_DATA' | transloco }}
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
}
